import React, { useEffect, useContext, useState } from 'react';
import $ from 'jquery';
import DataTable from 'datatables.net';
import { LoginContext } from '../../hooks/context/LoginContext';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Button from '../../componentes/ui/Button';
import MiSelect from '../../componentes/formulario/MiSelect';
import FormInput from '../../componentes/formulario/FormInput';
import TextArea from '../../componentes/formulario/TextArea';
import { Spinner } from 'react-bootstrap';
import { Accordion, Card } from "react-bootstrap";
import swal from 'sweetalert';
import { alertService } from '../../services/alertservice';
import { Alert } from '../../componentes/ui/Alert';
import useLogicForm from '../../hooks/useLogicForm';
import Cookies from 'universal-cookie';
import { getApiUrl, axiosPost, MiReplaceAll, getAhoraddmmyyyy, getAhorayyyymmdd, getPantDocFromNivel, setStockOptionsSelectUbi, getStockOptionsSelectUbi, getTitle, encryptData, getDecodedCookie, getNumNoLeidosExcedidos, getNumNoLeidosEnPlazo, getNumFromDataTraPdtAsignar } from '../../helpers/helperApp';
import { Fragment } from 'react';
import FormRow from '../../componentes/formulario/FormRow';
import { NavLink } from 'react-router-dom';

$.DataTable = DataTable;
const url = window.location;

function ManLog(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey, appCryptCom } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ documentos, saveDocumentos ] = useState([]);
    const [ loading, saveLoading ] = useState(false);
    const [ selectIdEquipo, saveSelectIdEquipo ] = useState(0);
    const [ inputDescripcion, saveInputDescripcion ] = useState("");
    const [ inputFecPro, saveInputFecPro ] = useState("");
    const [ inputFecUlt, saveInputFecUlt ] = useState(getAhorayyyymmdd()+" 00:00");
    const [ showModalEditar, saveShowModalEditar ] = useState(false);
    const [ selectIdEquipoModal, saveSelectIdEquipoModal ] = useState(0);
    const [ inputDescripcionModal, saveInputDescripcionModal ] = useState("");
    const [ inputFecProModal, saveInputFecProModal ] = useState("");
    const [ inputFecUltModal, saveInputFecUltModal ] = useState(getAhorayyyymmdd()+" 00:00");
    const [ lineaEditar, saveLineaEditar ] = useState(null);
    const [ acordeonPrin, saveAcordeonPrin ] = useState(null); 
    const [ mantenimientos, saveMantenimientos ] = useState([]);
    const [ mantenimientosPendientes, saveMantenimientosPendientes ] = useState([]);
    const [ pendientesAsignar, savePendientesAsignar ] = useState([]);
    const [ showModalMensaje, saveShowModalMensaje ] = useState(false);
    const [ mensajeId, saveMensajeId] = useState(0);
    const [ mensajeEstado, saveMensajeEstado] = useState(0);
    const [ mensajeDe, saveMensajeDe] = useState(0);
    const [ mensajePara, saveMensajePara] = useState(0);
    const [ mensajeEnvio, saveMensajeEnvio] = useState("");
    const [ mensajeRecordatorio, saveMensajeRecordatorio] = useState("");
    const [ mensajeLimite, saveMensajeLimite] = useState("");
    const [ mensajeLectura, saveMensajeLectura] = useState("");
    const [ mensajeMsg, saveMensajeMsg ] = useState("");   

    // ***** Custom Hook - Lógica de los formularios *****
    const { loadReg, saveLoadReg } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{ 
                    document.title = getTitle(confPantalla.config.trad, confPantalla.manlog.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        loadDocumentosTable();
                        loadMantenimientosTable();
                        loadMantenimientosPendientes();
                        loadPendientesAsignar();                           
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");

                // Token cancelación axios al desmontar componentes
                source.cancel();
        } 

    },[confPantalla])

    const loadDocumentosTable = async () => {
        
        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlog.controles.datatabledocumentos.getdata, data, source.token);
               
        if( typeof respuesta.data !== "string" ){
            saveDocumentos(respuesta.data);            
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }
        
        saveLoading(false);
    }

    const loadMantenimientosTable = async () => {
        
        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlog.controles.datatablemantenimientos.getdata, data, source.token);
               
        if( typeof respuesta.data !== "string" ){
            saveMantenimientos(respuesta.data);            
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }
        
        saveLoading(false);
    }

    const loadMantenimientosPendientes = async (btnDataTable=false) => {
        
        saveLoading(true);
        
        const data = new FormData();                            
        if(btnDataTable == true){                        
            let btn = document.getElementsByClassName('filterBtnManlogV2');
            if(btn && btn[0] && btn[0].classList.contains('active')) {
                btn[0].classList.remove('active');
            } else if(btn && btn[0].classList) {
                btn[0].classList.add('active');
                data.append("filhis", true);
            }            
        }else{
            let btn = document.getElementsByClassName('filterBtnManlogV2');
            if(btn && btn[0] && btn[0].classList.contains('active')) {                
                data.append("filhis", true);
            }
        }
        data.append("validacion", apiKey());        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlogv2.controles.datatablemantenimientospendientes.getdata, data, source.token);
               
        if( typeof respuesta.data !== "string" ){            
            saveMantenimientosPendientes(respuesta.data);            
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }
        
        saveLoading(false);
    }

    const loadPendientesAsignar = async () => {
        
        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlogv2.controles.datatablependientesdeasignar.getdata, data, source.token);
                
        if( typeof respuesta.data !== "string" ){
            savePendientesAsignar(respuesta.data);            
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }
        
        saveLoading(false);
    }

    const createNew = () => {
        if (new Date(inputFecUlt) > new Date(inputFecPro)){
            // Error la fecha de próxima ejecución debe ser posterior a la de última ejecución
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.manlog.txterrordates.title}`, {autoClose: true});   
            return;
        }
        
        swal({
            title: confPantalla.manlog.swal.title,
            text: confPantalla.manlog.swal.text.title,
            icon: "warning",
            buttons: {
                cancel : {text: confPantalla.manlog.swal.btncancelar.title, className:'btn btn-flat mr-1 btn-outline-secondary', visible: true},
                confirm : {text: confPantalla.manlog.swal.btnaceptar.title, className:'btn btn-flat btn-outline-success btnSwalSuccess'}
            } 
        }).then(confirmacion => {
            if(confirmacion){
                createNewAction();
            }
        })
        
        
    }

    const createNewAction = async () => {
        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());
        data.append("idequ", selectIdEquipo);
        data.append("nom1", inputDescripcion);
        data.append("fecpro", inputFecPro);
        data.append("fecult", inputFecUlt);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlog.controles.createdoc, data, source.token);
               
        if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }else{
            saveSelectIdEquipo(0);
            saveInputDescripcion("");
            saveInputFecUlt(getAhorayyyymmdd()+" 00:00");
            saveInputFecPro("");
        }
        
        await loadDocumentosTable();
        await loadMantenimientosPendientes();
        await loadPendientesAsignar();

        saveLoading(false);
    }


    const showEditarLinea = (e, rowData) =>{
        saveLineaEditar(rowData);        
        saveSelectIdEquipoModal(rowData.idequ);
        saveInputDescripcionModal(rowData.descripcionNoHtml);
        saveInputFecUltModal(rowData.fecult);
        saveInputFecProModal(rowData.fecpro);
        saveShowModalEditar(true);
    }

    const accionBtnEditar = async () => {
        if (new Date(inputFecUltModal) > new Date(inputFecProModal)){
            // Error la fecha de próxima ejecución debe ser posterior a la de última ejecución
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.manlog.txterrordates.title}`, {autoClose: true});   
            return;
        }

        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());
        data.append("iddoc", lineaEditar.id);
        data.append("idequ", selectIdEquipoModal);
        data.append("nom1", inputDescripcionModal);
        data.append("fecpro", inputFecProModal);
        data.append("fecult", inputFecUltModal);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlog.modaleditar.editar.senddata, data, source.token);
               
        if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }
        
        await loadDocumentosTable();
        await loadMantenimientosPendientes();
        await loadPendientesAsignar();
        saveLoading(false);
        saveShowModalEditar(false);

    }
    
    const open = (e, rowData) => {          
        let ruta = rowData.ruta;
        const esUrl = ruta.startsWith('http://') || ruta.startsWith('https://') || ruta.startsWith('www.');
        const baseUrl = getApiUrl(window.location.origin);

        try {            
            if (ruta.startsWith('www.')) {
                ruta = `https://${ruta}`;
            }

            if (esUrl) {
                // Intentar abrir la URL en una nueva pestaña
                const nuevaVentana = window.open(ruta, '_blank');
                if (!nuevaVentana) {
                    alertService.error(`<i class="fal fa-times-octagon mr-1"></i> ${confPantalla.manlog.txterroropen.title}`, { autoClose: true });
                }
            } else {
                // Comprobar si es un archivo local o una ruta relativa
                const archivoUrl = ruta.startsWith('file://') ? ruta : `${baseUrl}${ruta}`;
                const nuevaVentana = window.open(archivoUrl, '_blank');
                if (!nuevaVentana) {
                    alertService.error(`<i class="fal fa-times-octagon mr-1"></i> ${confPantalla.manlog.txterroropen.title}`, { autoClose: true });
                }
            }
        } catch (error) {            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i> ${confPantalla.manlog.txterroropen.title}`, { autoClose: true });
        }
    }

    const showMensaje = (e, rowData) =>{                 
        saveLineaEditar(rowData);                
        saveSelectIdEquipoModal(rowData.idori);                 
        
        
        saveMensajeId(rowData.id);
        saveMensajeEstado(rowData.msg_idest);
        saveMensajeDe(rowData.from_idage);
        saveMensajePara(rowData.to_idage);
        saveMensajeEnvio(rowData.send_date+"T00:00");
        saveMensajeRecordatorio(rowData.rem_date+"T00:00");
        saveMensajeLimite(rowData.exp_date+"T00:00");
        saveMensajeLectura(rowData.read_date+"T00:00");
        saveMensajeMsg(rowData.msg_sub);
        
        saveShowModalMensaje(true);
    }

    const setMantenimientoToForm = async (e, rowData) => {          
        saveSelectIdEquipo(rowData.idequ);
        saveInputDescripcion(rowData.descripcionnohtml);                        
    }

    const accionMensaje = async (e) => {

        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());
        data.append("id", mensajeId)
        data.append("msg_idest", mensajeEstado);
        data.append("rem_date", mensajeRecordatorio);
        data.append("exp_date", mensajeLimite);
        data.append("to_idage", mensajePara);
        data.append("msg_sub", mensajeMsg);        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlogv2.modalmensaje.updatemensaje, data, source.token);
                
        if( typeof respuesta.data !== "string" ){
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.manlogv2.modalmensaje.mensajeactualizado.title}`, {autoClose: true});
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }

        await loadMantenimientosPendientes();             

        saveLoading(false);
        saveShowModalMensaje(false);
        
    }


    const handleSelect= (selectedItem, nameOfComponent, saveData) => {
        if( selectedItem ){
            saveData(selectedItem.value) 
        }else{
            saveData(0)
        }
    }

    const handleInput = (e, save) => {     
        save(e.target.value)
    }

    const toogleAcordeon = (id) => {
        if( acordeonPrin == id ){
            saveAcordeonPrin(null);                    
        }else{
            saveAcordeonPrin(id);                    
        }        
    }

    
    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
            </div>   
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Alert fondo={true} />
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">                
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                            <Section
                                tituloenhtml={true}
                                titulo={ confPantalla.manlog.section.titulo }  
                                icono={ confPantalla.manlog.section.icono } 
                                col={ confPantalla.manlog.section.col }
                                informes={confPantalla.manlog.controles.informes}                                
                            >
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { selectIdEquipo  }   
                                    loading=     { loading ? true : false }
                                    id=          { confPantalla.manlog.controles.idequ.id }    
                                    name=        { confPantalla.manlog.controles.idequ.name }   
                                    label=       { confPantalla.manlog.controles.idequ.label }    
                                    placeholder= { confPantalla.manlog.controles.idequ.placeholder }
                                    col=         { confPantalla.manlog.controles.idequ.col } 
                                    isClearable= { confPantalla.manlog.controles.idequ.isclearable }
                                    isSearchable={ confPantalla.manlog.controles.idequ.issearchable }
                                    dataType=    { confPantalla.manlog.controles.idequ.datatype }
                                    data=        { confPantalla.manlog.controles.idequ.data }
                                    required=    { confPantalla.manlog.controles.idequ.required } 
                                    disabled=  { confPantalla.manlog.controles.idequ.disabled }
                                    readOnly =   { confPantalla.manlog.controles.idequ.readonly }
                                    disablethisid={confPantalla.manlog.controles.idequ.disablethisid}
                                    disableids={confPantalla.manlog.controles.idequ.disableids}                                    
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveSelectIdEquipo) }
                                />
                                <FormInput   
                                    clasesInput={ " inputRequired " }                                                     
                                    estadoForm= { "" }
                                    value=      { inputDescripcion }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlog.controles.descripcion.id }   
                                    type=       { confPantalla.manlog.controles.descripcion.type }  
                                    name=       { confPantalla.manlog.controles.descripcion.name }   
                                    label=      { confPantalla.manlog.controles.descripcion.label }                                                       
                                    placeholder={ confPantalla.manlog.controles.descripcion.placeholder }    
                                    col=        { confPantalla.manlog.controles.descripcion.col } 
                                    required=   { confPantalla.manlog.controles.descripcion.required }
                                    readonly=   { confPantalla.manlog.controles.descripcion.readonly }
                                    disabled=   { confPantalla.manlog.controles.descripcion.disabled }
                                    change=     { e => handleInput(e, saveInputDescripcion) }
                                    onBlur=     {null}
                                    autoCompleteData = {documentos}
                                    saveSuggestion={saveInputDescripcion} 
                                />
                                <FormInput
                                    clasesInput={ " inputRequired " }
                                    estadoForm= { "" }
                                    value=      { inputFecUlt }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlog.controles.fecult.id }   
                                    type=       { confPantalla.manlog.controles.fecult.type }  
                                    name=       { confPantalla.manlog.controles.fecult.name }   
                                    label=      { confPantalla.manlog.controles.fecult.label }                                                       
                                    placeholder={ confPantalla.manlog.controles.fecult.placeholder }    
                                    col=        { confPantalla.manlog.controles.fecult.col } 
                                    required=   { confPantalla.manlog.controles.fecult.required }
                                    readonly=   { confPantalla.manlog.controles.fecult.readonly }
                                    disabled=   { confPantalla.manlog.controles.fecult.disabled }
                                    change=     { e => handleInput(e, saveInputFecUlt) }
                                    onBlur=     {null} 
                                />                                 
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { inputFecPro }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlog.controles.fecpro.id }   
                                    type=       { confPantalla.manlog.controles.fecpro.type }  
                                    name=       { confPantalla.manlog.controles.fecpro.name }   
                                    label=      { confPantalla.manlog.controles.fecpro.label }                                                       
                                    placeholder={ confPantalla.manlog.controles.fecpro.placeholder }    
                                    col=        { confPantalla.manlog.controles.fecpro.col } 
                                    required=   { confPantalla.manlog.controles.fecpro.required }
                                    readonly=   { confPantalla.manlog.controles.fecpro.readonly }
                                    disabled=   { confPantalla.manlog.controles.fecpro.disabled }
                                    change=     { e => handleInput(e, saveInputFecPro) }
                                    onBlur=     {null} 
                                /> 
                            </FormRow>
                            <p className="font-italic text-center">{ confPantalla.manlog.txtrequired.title }</p>                                
                            <Button 
                                clases={ "col-12 mt-2 mb-4" }
                                estadoForm={ loading ? "disabled" : "" }
                                color={ "success" }  
                                type="button" 
                                icono={ "" }   
                                id="btnnew"     
                                texto={ confPantalla.manlog.controles.btnnew.title }   
                                accion={ createNew } 
                                disabled={ inputDescripcion == "" || inputFecUlt == "" || loading == true ? true : false }
                            /> 
                            {   loading == true ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }
                            <Accordion defaultActiveKey={""}  >
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => toogleAcordeon('0')} className={ acordeonPrin == "0" ? "activeAcordeon" : "" }>
                                        <i className={ confPantalla.manlog.mantenimientos.icono } ></i> { confPantalla.manlog.mantenimientos.titulo }
                                        {
                                            acordeonPrin == "0"
                                            ?
                                                <i className={"fal fa-chevron-up float-right fa-2x"} ></i>
                                            :
                                                <i className={"fal fa-chevron-down float-right fa-2x"} ></i>
                                        }
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="0" className={"slowAcordeon"} >
                                        <Card.Body>                                        
                                            <MiDataTable 
                                                estadoForm= { "" }
                                                formulario={ {id:0} }
                                                id={"manlogmant"}
                                                columnas={confPantalla.manlog.controles.datatablemantenimientos.columns}
                                                data={mantenimientos}
                                                buttons={confPantalla.manlog.controles.datatablemantenimientos.buttons}
                                                ordering={confPantalla.manlog.controles.datatablemantenimientos.ordering}
                                                order={confPantalla.manlog.controles.datatablemantenimientos.order}
                                                searching={confPantalla.manlog.controles.datatablemantenimientos.searching}
                                                paging={confPantalla.manlog.controles.datatablemantenimientos.paging}
                                                select={confPantalla.manlog.controles.datatablemantenimientos.select}
                                                pagelength={confPantalla.manlog.controles.datatablemantenimientos.pagelength}
                                                // saveLoadingTable={ saveLoading }
                                                // loadingTable={loading}
                                                columnactions={confPantalla.manlog.controles.datatablemantenimientos.columnactions.title}
                                                linkColumns={confPantalla.manlog.controles.datatablemantenimientos.linkColumns}
                                                traduction={confPantalla.config.trad.components.datatable}
                                                functionClickTd={ open }                                
                                            />   
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => toogleAcordeon('1')} className={ acordeonPrin == "1" ? "activeAcordeon" : "" }>
                                        <i className={ confPantalla.manlogv2.mantenimientospendientes.icono } ></i> 
                                        { confPantalla.manlogv2.mantenimientospendientes.titulo } 
                                        <span className="alert-danger ml-2 pl-3 pr-3 pt-2 pb-2 " style={{borderRadius: "5px"}}>
                                            {getNumNoLeidosExcedidos(mantenimientosPendientes)}
                                        </span>
                                        <span className="alert-success ml-2 pl-3 pr-3 pt-2 pb-2 " style={{borderRadius: "5px"}}>
                                            {getNumNoLeidosEnPlazo(mantenimientosPendientes)}
                                        </span>
                                        {/* {
                                            cookies.get('nivel') <= '3' 
                                            ? 
                                                <Fragment>
                                                    <span className='mr-1 ml-1'> / </span>
                                                    { confPantalla.manlogv2.avisosdemantenimientos.titulo }
                                                    <span className="alert-danger ml-2 pl-3 pr-3 pt-2 pb-2 " style={{borderRadius: "5px"}}>
                                                        {getNumFromDataTraPdtAsignar(pendientesAsignar, true, false)}
                                                    </span>
                                                    <span className="alert-success ml-2 pl-3 pr-3 pt-2 pb-2 " style={{borderRadius: "5px"}}>
                                                        {getNumFromDataTraPdtAsignar(pendientesAsignar, false, false)}
                                                    </span>
                                                </Fragment>
                                            : null
                                        } */}
                                        {
                                            acordeonPrin == "1"
                                            ?
                                                <i className={"fal fa-chevron-up float-right fa-2x"} ></i>
                                            :
                                                <i className={"fal fa-chevron-down float-right fa-2x"} ></i>
                                        }
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="1" className={"slowAcordeon"} >
                                        <Card.Body>                                        
                                            <MiDataTable 
                                                estadoForm= { "" }
                                                formulario={ {id:0} }
                                                id={"manlogv2pend"}
                                                columnas={
                                                    cookies.get('nivel') > '3'
                                                    ? confPantalla.manlogv2.controles.datatablemantenimientospendientes.columnstrabajador
                                                    : confPantalla.manlogv2.controles.datatablemantenimientospendientes.columns
                                                }
                                                data={mantenimientosPendientes}
                                                buttons={confPantalla.manlogv2.controles.datatablemantenimientospendientes.buttons}
                                                ordering={confPantalla.manlogv2.controles.datatablemantenimientospendientes.ordering}
                                                order={confPantalla.manlogv2.controles.datatablemantenimientospendientes.order}
                                                searching={confPantalla.manlogv2.controles.datatablemantenimientospendientes.searching}
                                                paging={confPantalla.manlogv2.controles.datatablemantenimientospendientes.paging}
                                                select={confPantalla.manlogv2.controles.datatablemantenimientospendientes.select}
                                                pagelength={confPantalla.manlogv2.controles.datatablemantenimientospendientes.pagelength}
                                                // saveLoadingTable={ saveLoading }
                                                // loadingTable={loading}
                                                columnactions={confPantalla.manlogv2.controles.datatablemantenimientospendientes.columnactions.title}
                                                linkColumns={confPantalla.manlogv2.controles.datatablemantenimientospendientes.linkColumns}
                                                traduction={confPantalla.config.trad.components.datatable}
                                                functionClickTd={ showMensaje }
                                                clickBtnDataTableButtons={loadMantenimientosPendientes}                               
                                            />
                                            {
                                            // cookies.get('nivel') <= '3' 
                                            // ?
                                            //     <Fragment>
                                            //         {/* <div className="row justify-content-md-center">                                             
                                            //             <div className="col-md-12 col-lg-2">
                                            //                 <div className="alert alert-danger alertHelp" role="alert">
                                            //                     {getNumFromDataTraPdtAsignar(pendientesAsignar, true)}
                                            //                     {confPantalla.manlogv2.controles.datatablependientesdeasignar.leyendapendientes.excedido.title}
                                            //                 </div>
                                            //             </div>                                            
                                            //             <div className="col-md-12 col-lg-2">
                                            //                 <div className="alert alert-success alertHelp" role="alert">
                                            //                     {getNumFromDataTraPdtAsignar(pendientesAsignar, false)}
                                            //                     {confPantalla.manlogv2.controles.datatablependientesdeasignar.leyendapendientes.enplazo.title}
                                            //                 </div>
                                            //             </div>                                                       
                                            //         </div> */}
                                            //         <MiDataTable 
                                            //             estadoForm= { "" }
                                            //             formulario={ {id:0} }
                                            //             id={"manlogv2pendientesdeasignar"}
                                            //             columnas={confPantalla.manlogv2.controles.datatablependientesdeasignar.columns}
                                            //             data={pendientesAsignar}
                                            //             linkColumns={confPantalla.manlogv2.controles.datatablependientesdeasignar.linkColumns}
                                            //             buttons={confPantalla.manlogv2.controles.datatablependientesdeasignar.buttons}
                                            //             ordering={confPantalla.manlogv2.controles.datatablependientesdeasignar.ordering}
                                            //             order={confPantalla.manlogv2.controles.datatablependientesdeasignar.order}
                                            //             searching={confPantalla.manlogv2.controles.datatablependientesdeasignar.searching}
                                            //             paging={confPantalla.manlogv2.controles.datatablependientesdeasignar.paging}
                                            //             select={confPantalla.manlogv2.controles.datatablependientesdeasignar.select}
                                            //             pagelength={confPantalla.manlogv2.controles.datatablependientesdeasignar.pagelength}
                                            //             // saveLoadingTable={ saveLoadingTable }
                                            //             // loadingTable={loadingTable}
                                            //             columnactions={confPantalla.manlogv2.controles.datatablependientesdeasignar.columnactions.title}
                                            //             traduction={confPantalla.config.trad.components.datatable}
                                            //             functionClickTd={ setMantenimientoToForm }
                                            //         />
                                            //     </Fragment>
                                            // :
                                            //     null
                                        }                                            
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="2" onClick={() => toogleAcordeon('2')} className={ acordeonPrin == "2" ? "activeAcordeon" : "" }>
                                        <i className={ confPantalla.manlog.historicos.icono } ></i> { confPantalla.manlog.historicos.titulo }
                                        {
                                            acordeonPrin == "2"
                                            ?
                                                <i className={"fal fa-chevron-up float-right fa-2x"} ></i>
                                            :
                                                <i className={"fal fa-chevron-down float-right fa-2x"} ></i>
                                        }
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="2" className={"slowAcordeon"} >
                                        <Card.Body>                                        
                                            <MiDataTable 
                                                estadoForm= { "" }
                                                formulario={ {id:0} }
                                                id={"manlog"}
                                                columnas={confPantalla.manlog.controles.datatabledocumentos.columns}
                                                data={documentos}
                                                buttons={confPantalla.manlog.controles.datatabledocumentos.buttons}
                                                ordering={confPantalla.manlog.controles.datatabledocumentos.ordering}
                                                order={confPantalla.manlog.controles.datatabledocumentos.order}
                                                searching={confPantalla.manlog.controles.datatabledocumentos.searching}
                                                paging={confPantalla.manlog.controles.datatabledocumentos.paging}
                                                select={confPantalla.manlog.controles.datatabledocumentos.select}
                                                pagelength={confPantalla.manlog.controles.datatabledocumentos.pagelength}
                                                // saveLoadingTable={ saveLoading }
                                                // loadingTable={loading}
                                                columnactions={confPantalla.manlog.controles.datatabledocumentos.columnactions.title}
                                                linkColumns={confPantalla.manlog.controles.datatabledocumentos.linkColumns}
                                                traduction={confPantalla.config.trad.components.datatable}
                                                functionClickTd={ cookies.get('nivel') <= '2' ? showEditarLinea : null }                                
                                            />   
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                {
                    showModalEditar == true
                    ?
                    <Modal
                        show={showModalEditar}
                        onHide={ () => saveShowModalEditar(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        <Modal.Header closeButton>
                            <h4>{confPantalla.manlog.modaleditar.header.title}</h4>
                        </Modal.Header>                         
                        <Modal.Body>
                        <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { selectIdEquipoModal  }   
                                    loading=     { loading ? true : false }
                                    id=          { confPantalla.manlog.modaleditar.idequ.id }    
                                    name=        { confPantalla.manlog.modaleditar.idequ.name }   
                                    label=       { confPantalla.manlog.modaleditar.idequ.label }    
                                    placeholder= { confPantalla.manlog.modaleditar.idequ.placeholder }
                                    col=         { confPantalla.manlog.modaleditar.idequ.col } 
                                    isClearable= { confPantalla.manlog.modaleditar.idequ.isclearable }
                                    isSearchable={ confPantalla.manlog.modaleditar.idequ.issearchable }
                                    dataType=    { confPantalla.manlog.modaleditar.idequ.datatype }
                                    data=        { confPantalla.manlog.modaleditar.idequ.data }
                                    required=    { confPantalla.manlog.modaleditar.idequ.required } 
                                    disabled=  { confPantalla.manlog.modaleditar.idequ.disabled }
                                    readOnly =   { confPantalla.manlog.modaleditar.idequ.readonly }
                                    disablethisid={confPantalla.manlog.modaleditar.idequ.disablethisid}
                                    disableids={confPantalla.manlog.modaleditar.idequ.disableids}                                    
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveSelectIdEquipoModal) }
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { inputDescripcionModal }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlog.modaleditar.descripcion.id }   
                                    type=       { confPantalla.manlog.modaleditar.descripcion.type }  
                                    name=       { confPantalla.manlog.modaleditar.descripcion.name }   
                                    label=      { confPantalla.manlog.modaleditar.descripcion.label }                                                       
                                    placeholder={ confPantalla.manlog.modaleditar.descripcion.placeholder }    
                                    col=        { confPantalla.manlog.modaleditar.descripcion.col } 
                                    required=   { confPantalla.manlog.modaleditar.descripcion.required }
                                    readonly=   { confPantalla.manlog.modaleditar.descripcion.readonly }
                                    disabled=   { confPantalla.manlog.modaleditar.descripcion.disabled }
                                    change=     { e => handleInput(e, saveInputDescripcionModal) }
                                    onBlur=     {null}
                                    // autoCompleteData = {documentos}
                                    // saveSuggestion={saveInputDescripcion} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { inputFecUltModal }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlog.modaleditar.fecult.id }   
                                    type=       { confPantalla.manlog.modaleditar.fecult.type }  
                                    name=       { confPantalla.manlog.modaleditar.fecult.name }   
                                    label=      { confPantalla.manlog.modaleditar.fecult.label }                                                       
                                    placeholder={ confPantalla.manlog.modaleditar.fecult.placeholder }    
                                    col=        { confPantalla.manlog.modaleditar.fecult.col } 
                                    required=   { confPantalla.manlog.modaleditar.fecult.required }
                                    readonly=   { confPantalla.manlog.modaleditar.fecult.readonly }
                                    disabled=   { confPantalla.manlog.modaleditar.fecult.disabled }
                                    change=     { e => handleInput(e, saveInputFecUltModal) }
                                    onBlur=     {null} 
                                />                                 
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { inputFecProModal }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlog.modaleditar.fecpro.id }   
                                    type=       { confPantalla.manlog.modaleditar.fecpro.type }  
                                    name=       { confPantalla.manlog.modaleditar.fecpro.name }   
                                    label=      { confPantalla.manlog.modaleditar.fecpro.label }                                                       
                                    placeholder={ confPantalla.manlog.modaleditar.fecpro.placeholder }    
                                    col=        { confPantalla.manlog.modaleditar.fecpro.col } 
                                    required=   { confPantalla.manlog.modaleditar.fecpro.required }
                                    readonly=   { confPantalla.manlog.modaleditar.fecpro.readonly }
                                    disabled=   { confPantalla.manlog.modaleditar.fecpro.disabled }
                                    change=     { e => handleInput(e, saveInputFecProModal) }
                                    onBlur=     {null} 
                                /> 
                            </FormRow>
                            <p className="font-italic text-center">{ confPantalla.manlog.txtrequired.title }</p>
                            {   loading ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ accionBtnEditar }
                                        disabled={inputDescripcionModal == "" || inputFecUltModal == "" || loading == true ? true : false}                                        
                                >
                                    {confPantalla.manlog.modaleditar.btnaceptar.title}
                                </button>
                                <button 
                                        className="btn btn-danger mt-1"
                                        onClick={ () => saveShowModalEditar(false) }                                        
                                >
                                    {confPantalla.manlog.modaleditar.btncancelar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                }
                {
                    showModalMensaje == true
                    ?
                    <Modal
                        show={showModalMensaje}
                        onHide={ () => saveShowModalMensaje(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        {/* <Modal.Header closeButton> */}
                        <Modal.Header>
                            <div className='col-12' style={{display: "flex", justifyContent: "space-between" , alignItems: "center"}}>
                                <h4>{confPantalla.manlogv2.modalmensaje.header.title}</h4>                                 
                            </div>                            
                        </Modal.Header>                         
                        <Modal.Body>
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { mensajeEstado }   
                                    loading=     { loadReg ? true : false }
                                    id=          { confPantalla.manlogv2.modalmensaje.msg_idest.id }    
                                    name=        { confPantalla.manlogv2.modalmensaje.msg_idest.name }   
                                    label=       { confPantalla.manlogv2.modalmensaje.msg_idest.label }    
                                    placeholder= { confPantalla.manlogv2.modalmensaje.msg_idest.placeholder }
                                    col=         { confPantalla.manlogv2.modalmensaje.msg_idest.col } 
                                    isClearable= { confPantalla.manlogv2.modalmensaje.msg_idest.isclearable }
                                    isSearchable={ confPantalla.manlogv2.modalmensaje.msg_idest.issearchable }
                                    dataType=    { confPantalla.manlogv2.modalmensaje.msg_idest.datatype }
                                    data=        { confPantalla.manlogv2.modalmensaje.msg_idest.data }
                                    required=    { confPantalla.manlogv2.modalmensaje.msg_idest.required } 
                                    disabled=  { confPantalla.manlogv2.modalmensaje.msg_idest.disabled }
                                    readOnly =   { confPantalla.manlogv2.modalmensaje.msg_idest.readonly }
                                    disablethisid={confPantalla.manlogv2.modalmensaje.msg_idest.disablethisid}
                                    disableids={confPantalla.manlogv2.modalmensaje.msg_idest.disableids}                                    
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveMensajeEstado)  }
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { mensajeRecordatorio }
                                    loading=    { loadReg ? true : false }
                                    id=         { confPantalla.manlogv2.modalmensaje.rem_date.id }   
                                    type=       { confPantalla.manlogv2.modalmensaje.rem_date.type }  
                                    name=       { confPantalla.manlogv2.modalmensaje.rem_date.name }   
                                    label=      { confPantalla.manlogv2.modalmensaje.rem_date.label }                                                       
                                    placeholder={ confPantalla.manlogv2.modalmensaje.rem_date.placeholder }    
                                    col=        { confPantalla.manlogv2.modalmensaje.rem_date.col } 
                                    required=   { confPantalla.manlogv2.modalmensaje.rem_date.required }
                                    readonly=   { confPantalla.manlogv2.modalmensaje.rem_date.readonly }
                                    disabled=   { confPantalla.manlogv2.modalmensaje.rem_date.disabled }                                    
                                    change=     { e => handleInput(e, saveMensajeRecordatorio) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { mensajeLimite }
                                    loading=    { loadReg ? true : false }
                                    id=         { confPantalla.manlogv2.modalmensaje.exp_date.id }   
                                    type=       { confPantalla.manlogv2.modalmensaje.exp_date.type }  
                                    name=       { confPantalla.manlogv2.modalmensaje.exp_date.name }   
                                    label=      { confPantalla.manlogv2.modalmensaje.exp_date.label }                                                       
                                    placeholder={ confPantalla.manlogv2.modalmensaje.exp_date.placeholder }    
                                    col=        { confPantalla.manlogv2.modalmensaje.exp_date.col } 
                                    required=   { confPantalla.manlogv2.modalmensaje.exp_date.required }
                                    readonly=   { cookies.get('nivel') > '3' ? "readonly" : confPantalla.manlogv2.modalmensaje.exp_date.readonly }
                                    disabled=   { cookies.get('nivel') > '3' ? "disabled" : confPantalla.manlogv2.modalmensaje.exp_date.disabled }
                                    change=     { e => handleInput(e, saveMensajeLimite) }
                                    onBlur=     {null} 
                                />                                 
                            </FormRow>
                            <FormRow clases="" >
                                {/* <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { mensajeDe  }   
                                    loading=     { loadReg ? true : false }
                                    id=          { confPantalla.manlogv2.modalmensaje.from_idage.id }    
                                    name=        { confPantalla.manlogv2.modalmensaje.from_idage.name }   
                                    label=       { confPantalla.manlogv2.modalmensaje.from_idage.label }    
                                    placeholder= { confPantalla.manlogv2.modalmensaje.from_idage.placeholder }
                                    col=         { confPantalla.manlogv2.modalmensaje.from_idage.col } 
                                    isClearable= { confPantalla.manlogv2.modalmensaje.from_idage.isclearable }
                                    isSearchable={ confPantalla.manlogv2.modalmensaje.from_idage.issearchable }
                                    dataType=    { confPantalla.manlogv2.modalmensaje.from_idage.datatype }
                                    data=        { confPantalla.manlogv2.modalmensaje.from_idage.data }
                                    required=    { confPantalla.manlogv2.modalmensaje.from_idage.required } 
                                    disabled=  { confPantalla.manlogv2.modalmensaje.from_idage.disabled }
                                    readOnly =   { confPantalla.manlogv2.modalmensaje.from_idage.readonly }
                                    disablethisid={confPantalla.manlogv2.modalmensaje.from_idage.disablethisid}
                                    disableids={confPantalla.manlogv2.modalmensaje.from_idage.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveMensajeDe) }
                                />  */}
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { mensajePara  }   
                                    loading=     { loadReg ? true : false }
                                    id=          { confPantalla.manlogv2.modalmensaje.to_idage.id }    
                                    name=        { confPantalla.manlogv2.modalmensaje.to_idage.name }   
                                    label=       { confPantalla.manlogv2.modalmensaje.to_idage.label }    
                                    placeholder= { confPantalla.manlogv2.modalmensaje.to_idage.placeholder }
                                    col=         { confPantalla.manlogv2.modalmensaje.to_idage.col } 
                                    isClearable= { confPantalla.manlogv2.modalmensaje.to_idage.isclearable }
                                    isSearchable={ confPantalla.manlogv2.modalmensaje.to_idage.issearchable }
                                    dataType=    { confPantalla.manlogv2.modalmensaje.to_idage.datatype }
                                    data=        { confPantalla.manlogv2.modalmensaje.to_idage.data }
                                    required=    { confPantalla.manlogv2.modalmensaje.to_idage.required } 
                                    disabled=  { cookies.get('nivel') > '3' ? "disabled" : confPantalla.manlogv2.modalmensaje.to_idage.disabled }
                                    readOnly =   { cookies.get('nivel') > '3' ? "readonly" : confPantalla.manlogv2.modalmensaje.to_idage.readonly }
                                    disablethisid={confPantalla.manlogv2.modalmensaje.to_idage.disablethisid}
                                    disableids={confPantalla.manlogv2.modalmensaje.to_idage.disableids}                                    
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveMensajePara) }
                                />                                                               
                            </FormRow>
                            {/* <FormRow> */}
                                {/* <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { mensajeEnvio }
                                    loading=    { loadReg ? true : false }
                                    id=         { confPantalla.manlogv2.modalmensaje.send_date.id }   
                                    type=       { confPantalla.manlogv2.modalmensaje.send_date.type }  
                                    name=       { confPantalla.manlogv2.modalmensaje.send_date.name }   
                                    label=      { confPantalla.manlogv2.modalmensaje.send_date.label }                                                       
                                    placeholder={ confPantalla.manlogv2.modalmensaje.send_date.placeholder }    
                                    col=        { confPantalla.manlogv2.modalmensaje.send_date.col } 
                                    required=   { confPantalla.manlogv2.modalmensaje.send_date.required }
                                    readonly=   { confPantalla.manlogv2.modalmensaje.send_date.readonly }
                                    disabled=   { confPantalla.manlogv2.modalmensaje.send_date.disabled }
                                    change=     { e => handleInput(e, saveMensajeEnvio) }
                                    onBlur=     {null} 
                                /> */}                                
                                {/* <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { mensajeLectura }
                                    loading=    { loadReg ? true : false }
                                    id=         { confPantalla.manlogv2.modalmensaje.read_date.id }   
                                    type=       { confPantalla.manlogv2.modalmensaje.read_date.type }  
                                    name=       { confPantalla.manlogv2.modalmensaje.read_date.name }   
                                    label=      { confPantalla.manlogv2.modalmensaje.read_date.label }                                                       
                                    placeholder={ confPantalla.manlogv2.modalmensaje.read_date.placeholder }    
                                    col=        { confPantalla.manlogv2.modalmensaje.read_date.col } 
                                    required=   { confPantalla.manlogv2.modalmensaje.read_date.required }
                                    readonly=   { confPantalla.manlogv2.modalmensaje.read_date.readonly }
                                    disabled=   { confPantalla.manlogv2.modalmensaje.read_date.disabled }
                                    change=     { e => handleInput(e, saveMensajeLectura) }
                                    onBlur=     {null} 
                                /> */}
                            {/* </FormRow> */}
                            <FormRow>
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { mensajeMsg }
                                    loading=    { loadReg ? true : false }
                                    id=         { confPantalla.manlogv2.modalmensaje.msg_sub.id }   
                                    name=       { confPantalla.manlogv2.modalmensaje.msg_sub.name }
                                    rows=       { confPantalla.manlogv2.modalmensaje.msg_sub.rows }      
                                    label=      { confPantalla.manlogv2.modalmensaje.msg_sub.label }                                                       
                                    placeholder={ confPantalla.manlogv2.modalmensaje.msg_sub.placeholder }    
                                    col=        { confPantalla.manlogv2.modalmensaje.msg_sub.col } 
                                    required=   { confPantalla.manlogv2.modalmensaje.msg_sub.required }
                                    readonly=   { confPantalla.manlogv2.modalmensaje.msg_sub.readonly }                                                
                                    disabled=   { confPantalla.manlogv2.modalmensaje.msg_sub.disabled }
                                    change=     { e => handleInput(e, saveMensajeMsg) }
                                    onBlur=     {null} 
                                />
                            </FormRow>                                                                                  
                            {   loading ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>                                                                  
                                <button className='btn btn-success mt-1 mr-1' style={{marginTop: '32px'}}  
                                    onClick={ e => accionMensaje(e) }
                                    disabled={ loading == true ? true : false}
                                >                                    
                                    {confPantalla.manlogv2.modalmensaje.btnaceptar.title}
                                </button>                                                                       
                                <button 
                                    className="btn btn-danger mt-1"
                                    onClick={ () => saveShowModalMensaje(false) }
                                    disabled={ loading == true ? true : false}                                        
                                >
                                    {confPantalla.manlogv2.modalmensaje.btncancelar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                }
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default ManLog;